import React, {useRef} from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'

import Layout from '../layouts'
import LargeHero from "../components/elements/largeHero"
import Grid from '../components/elements/grid'
import { Canon, Body, SizedText } from '../components/elements/typography'
import SwipeNSaveSection from '../components/sections/swipeNSaveSection'
import Modal from '../components/molocules/modal/modal'
import {
  Player,
  ControlBar,
  ReplayControl,
  ForwardControl,
  CurrentTimeDisplay,
  TimeDivider,
  PlaybackRateMenuButton,
  VolumeMenuButton
} from 'video-react';
import ReviewSection from '../components/sections/reviewSection'


const ActivatePage = () => {

  const modalRef1 = useRef();

  return (
    <Layout isSubMenuOpen={false} forceRootMenu="/">
      <LargeHero.Container
        background={{
          backgroundColor: `#7ab0d7`, 
          backgroundSize: `53px 53px`,
          backgroundImage: `url('data:image/png;base64,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')`, 
          backgroundSize: `300px`,
          backgroundRepeat: `repeat`,
          paddingBottom: `5rem`,
          '@media (min-width: 1024px)': { paddingBottom: `8rem` } ,
        }}
        styles={{
          '#hero > div': { 
            display: `flex`,
            flexDirection: `column-reverse`,
            alignItems: `center`,
            '.heroImage': {marginBottom: `3rem`, maxWidth: `460px`}
        },
          '@media (min-width: 680px)': {
            '#hero > div': { flexDirection: `row` }
          },   
          '@media (min-width: 1500px)': {'#hero > div': { '.heroImage': { marginBottom: `0`}}}       
        }}
      >
        <LargeHero.Content>
          <SizedText as="h1" smallSize="2.027" largeSize="5.852" css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`, 'span': {display: `block`, lineHeight: `1`, padding: `0.05rem 0`, '@media (min-width: 755px)': {
            gridRowStart:  `-1`,}}}}>Your New Debit Card is Here</SizedText>
          <SizedText as="h2" smallSize="1.424" largeSize="2.566" css={{fontFamily: `source-sans-pro`, fontWeight: `300`, textTransform: `capitalize`, marginTop: `0.75rem`}}>Activate your card today.</SizedText>
          <div css={{marginTop: `2rem`}}>
            <a href="https://apps.apple.com/us/app/the-claxton-bank-mobile/id994317983?ign-mpt=uo%3D4"><StaticImage src="../images/products/digital-banking/app-store-badge.png" alt="Download on the App Store" height="50" width="168" /></a>
            <a href="https://play.google.com/store/apps/details?id=com.csiweb.digitalbanking.bk0704"><StaticImage src="../images/products/digital-banking/google-play-badge.png" alt="Get it on Google Play" height="50" width="168"/></a><br />
          </div>
        </LargeHero.Content>
        <LargeHero.Image>
          <StaticImage 
            css={{
              display: `block !important`,
              '@media (min-width: 680px)': { display: 'none !important' },
              '@media (min-width: 1300px)': { display: 'block !important' } 
            }} 
            src="../images/products/debit-cards/TCB_Debit-Card_straight-on.png" 
            alt="TCB Debit Card" 
          />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 680px)': { display: 'block !important' },
              '@media (min-width: 1300px)': { display: 'none !important' } 
            }} 
            src="../images/products/debit-cards/TCB_Debit-Card_straight-on_cropped.png" 
            alt="TCB Debit Card" 
          />
        </LargeHero.Image>
      </LargeHero.Container>

      <Grid.FullWidthSection css={{padding: `6rem 0`, alignItems: `center`}}>
        <Grid.Block start={['1','3','1','1','1', '2', '4', '4']} span={['14','10','7', '6', '6', '5','3', '3']}>
        <div css={{position: `relative`, padding: `0 3rem`, maxWidth: `428px`, margin: `0 auto`, '@media (min-width: 736px)': { margin: `0 0 0 auto` },}}>
            <div css={{position: `relative`, backgroundColor: `#000`}}>
              <video css={{
                position: `absolute`,
                zIndex: `0`,
                objectFit: `cover`,
                width: `77%`,
                marginLeft: `11.5%`,
                marginTop: `6%`,
                '&::-webkit-media-controls': {
                    display: `none !important`,
                }
              }} autoPlay muted playsInline loop>
                <source src="https://ik.imagekit.io/qh63zqy9z/tcbga_bank/videos/CardActivationScreen_ewJWSoib8.mp4?ik-sdk-version=javascript-1.4.3&updatedAt=1659900531924"  />     
              </video>
            </div>
              <img css={{position: `relative`, width: `100%`, zIndex: `9000`}} src="https://ik.imagekit.io/qh63zqy9z/tcbga_bank/videos/phone-overlay_wWJGf6EZM.png?ik-sdk-version=javascript-1.4.3&updatedAt=1659900948238" />
          </div>
        </Grid.Block>

        <Grid.Block start={['2','2','8','7','7', '7', '7', '7']} span={['12','12','6', '7', '7', '5','5']}>
          <Canon>Step 1. Activate Your Card</Canon>  
          <Body>
          <ol css={{paddingLeft: `1.5rem`, '@media (min-width: 736px)': { paddingLeft: `2.5rem` }}}>
            <li>Log into your digital banking acount.</li> 
            <li>Tap the Menu icon at the bottom of the screen to open the full menu.</li>
            <li>Tap on Manage Cards to open the card controls screen.</li>
            <li>Tap on the card that says “Activation Required” in yellow writing.</li>
            <li>Tap “Activate” at the bottom of the screen.</li>
            <li>The activation process will take a few seconds, and then you will receive a “Card Successfully Activated” message. Tap “Close Window”.</li>
            <li>Use your card to make purchases and get money anywhere you see the MasterCard logo.</li>
          </ol>
          </Body>
        </Grid.Block>
      </Grid.FullWidthSection>


      <Grid.FullWidthSection css={{padding: `6rem 0`, alignItems: `center`}}>
        <Grid.Block start={['1','3','1','1','1', '2', '4', '4']} span={['14','10','7', '6', '6', '5','3', '3']}>
        <div css={{position: `relative`, padding: `0 3rem`, maxWidth: `428px`, margin: `0 auto`, '@media (min-width: 736px)': { margin: `0 0 0 auto` },}}>
            <div css={{position: `relative`, backgroundColor: `#000`}}>
              <video css={{
                position: `absolute`,
                zIndex: `0`,
                objectFit: `cover`,
                width: `77%`,
                marginLeft: `11.5%`,
                marginTop: `6%`,
                '&::-webkit-media-controls': {
                    display: `none !important`,
                }
              }} autoPlay muted playsInline loop>
                <source src="https://ik.imagekit.io/qh63zqy9z/tcbga_bank/videos/PINChnageScreen_kSHS5z6ZS.mp4?ik-sdk-version=javascript-1.4.3&updatedAt=1659904736218"  />     
              </video>
            </div>
              <img css={{position: `relative`, width: `100%`, zIndex: `9000`}} src="https://ik.imagekit.io/qh63zqy9z/tcbga_bank/videos/phone-overlay_wWJGf6EZM.png?ik-sdk-version=javascript-1.4.3&updatedAt=1659900948238" />
          </div>
        </Grid.Block>
        <Grid.Block start={['2','2','8','7','7', '7', '7', '7']} span={['12','12','6', '7', '7', '5','5']}>
          <Canon>Step 2. Choose Your New PIN.</Canon>  
          <Body>
          <ol css={{paddingLeft: `1.5rem`, '@media (min-width: 736px)': { paddingLeft: `2.5rem` }}}>
            <li>Log into your digital banking acount.</li> 
            <li>Tap the Menu icon at the bottom of the screen to open the full menu.</li>
            <li>Tap on Manage Cards to open the card controls screen.</li>
            <li>Tap on the new card whose PIN you would like to set.</li>
            <li>Tap on "Change PIN"</li>
            <li>Enter the 4 digit PIN you would like to use, and then re-enter the PIN below to confirm.</li>
            <li>Once done, tap "Change Pin".</li>
            <li>After a few seconds, you will get a "Card PIN Successfully Changed" message and you can tap "Close Window".</li>
            <li>Use your card to make purchases and get money anywhere you see the MasterCard logo.</li>
          </ol>
          </Body>
        </Grid.Block>
      </Grid.FullWidthSection>

      <Grid.FullWidthSection css={{padding: `6rem 0`, alignItems: `center`}}>
        <Grid.Block start={['1','3','1','1','1', '2', '4', '4']} span={['14','10','7', '6', '6', '5','3', '3']}>
        <div css={{position: `relative`, padding: `0 3rem`, maxWidth: `428px`, margin: `0 auto`, '@media (min-width: 736px)': { margin: `0 0 0 auto` },}}>
            <div css={{position: `relative`, backgroundColor: `#000`}}>
              <video css={{
                position: `absolute`,
                zIndex: `0`,
                objectFit: `cover`,
                width: `77%`,
                marginLeft: `11.5%`,
                marginTop: `6%`,
                '&::-webkit-media-controls': {
                    display: `none !important`,
                }
              }} autoPlay muted playsInline loop>
                <source src="https://ik.imagekit.io/qh63zqy9z/tcbga_bank/videos/applepay_FxLALgfJG.mp4?ik-sdk-version=javascript-1.4.3&updatedAt=1662408878597"  />     
              </video>
            </div>
              <img css={{position: `relative`, width: `100%`, zIndex: `9000`}} src="https://ik.imagekit.io/qh63zqy9z/tcbga_bank/videos/phone-overlay_wWJGf6EZM.png?ik-sdk-version=javascript-1.4.3&updatedAt=1659900948238" />
          </div>
        </Grid.Block>
        <Grid.Block start={['2','2','8','7','7', '7', '7', '7']} span={['12','12','6', '7', '7', '5','5']}>
          <Canon>Step 3. Add your card to your mobile wallet</Canon>  
          <Body>
          <ol css={{paddingLeft: `1.5rem`, marginBottom: `3rem`, '@media (min-width: 736px)': { paddingLeft: `2.5rem` }}}>
            <li>Open your wallet app.</li> 
            <li>Click on the + sign to add a new card.</li>
            <li>Tap on Debit or Credit Card.</li>
            <li>Tap continue.</li>
            <li>Follow the instructions on the screen, and accept the terms and conditions.  </li>
            <li>Verify your information by calling TCB at 912-739-3322.</li>
          </ol>
          </Body>
          <StaticImage 
            src="../images/products/digital-banking/mobile-wallet-logos.png" 
            alt="Logos of supported wallets: Apple Pay, Google Pay, Samsung Pay, Fitbit Pay, and Garmin Pay" 
          />
        </Grid.Block>
      </Grid.FullWidthSection>

      <SwipeNSaveSection />



      <ReviewSection />

</Layout>
  )
}

export default ActivatePage


